<!--左邊菜單-->
<template>
  <el-scrollbar style="height:100%;" :native="true" :style="menu_theme">
    <div class="container_menu">
      <el-menu :default-active="$route.name == null ? '' : $route.name.replace('_edit', '')" class="el-menu-vertical-demo"
        @open="handleOpen" @close="handleClose" :v-model="true" :unique-opened="false" :collapse-transition="false"
        mode="vertical" :collapse="isCollapse" :background-color="menu_theme.background" :text-color="menu_theme.color"
        v-if="(this.IsMobile() != null && isCollapse) ? false : true" :default-openeds="defaultOpeneds">
        <!--处理展开收起效果-->
        <div v-if="isCollapse">
          <img src="/Company_logo.ico" :style="menu_theme" style="height: 40px; margin-left: 12px" />
        </div>
        <div v-else>
          <h3>
            <img src="/Company_logo.ico" :style="menu_theme" style="height: 40px; vertical-align: middle" /><span
            :style="menu_theme" style="color: #2b363c; font-size: 25px;font-weight: bold;" class="home_title">公司系統</span>
          </h3>
        </div>
        <div class="container_menu" :style="{ height: cheight }">
          <!--动态遍历菜单-->
          <el-menu-item v-for="item in noChildren" :key="item.name" :index="item.name" @click="clickMenu(item)"
            ref="subMenu" v-show="$route.meta.istrun == false || $route.meta.istrun == 'undefined'">
            <!--动态class使用Es6写法-->
            <i :class="`el-icon-${item.icon}`"></i>
            <span slot="title">{{ $t(item.label) }}</span>
          </el-menu-item>
          <el-submenu v-for="item in hasChildren" :key="item.label" :index="item.label">
            <template slot="title">
              <i :class="`el-icon-${item.icon}`"></i>
              <span slot="title">{{ $t(item.label) }}</span>
            </template>
            <el-menu-item-group v-for="subItem in item.children.filter(m=>m.meta == null || m.meta.istrun == false)" :key="subItem.path">
              <el-menu-item @click="clickMenu(subItem)" :index="subItem.path">
                <i :class="`el-icon-${item.icon}`"></i>
                {{ $t(subItem.label) }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!--讓手機顯示左菜單全部顯示-->
          <el-menu-item v-if="IsMobile() != null">
            <div style="height: 80px;">&nbsp;</div>
          </el-menu-item>
        </div>
      </el-menu>
    </div>
  </el-scrollbar>
</template>
<style lang="less" scoped>
//.el-menu-vertical-demo:not(.el-menu--collapse) {
// 後續設置固定寬還是自適應 width: 260px;
//}

h3 {
  color: #fff;
  text-align: center;
  line-height: 48px;
  font-size: 16px;
  font-weight: 400;
}

.el-menu-vertical-demo {
  /* 适应整屏 */
  height: auto;
  border: none;
}

/deep/ .el-scrollbar__wrap {
  overflow: hidden;
}

.container_menu {
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
.container_menu::-webkit-scrollbar {
    /*滾動條整體樣式*/
    width: 8px; /*高寬分別對應橫豎滾動條的尺寸*/
    height: 10px;
}

.container_menu::-webkit-scrollbar-thumb {
    /*滾動條裏面小方塊*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
}

.container_menu::-webkit-scrollbar-track {
    background-color: #f6f6f6;
}
.container_menu::-webkit-scrollbar-thumb,
.container_menu::-webkit-scrollbar-track {
    border: 0;
}

</style>
<script>
import FixiOSBug from "@/mixins/FixiOSBug";
import { IsMobile } from "@/script/common";
export default {
  mixins: [FixiOSBug],
  data() {
    return {
      defaultOpeneds: ["維修", "報表", "基本設定", "值班/請假", "基礎資料", "微信報表管理", "WechatReport"], // 包含所有子菜单的 index 值的数组
    };
  },
  methods: {
    handleOpen(key, keyPath) {

    },
    handleClose(key, keyPath) {

    },
    // 点击菜单
    clickMenu(item) {
      // 如果左側菜單點擊時，監測到tabList存在對應路由的新增/修改頁面時切換到Tab
      if (this.$store.state.tab.tabList.findIndex((val) => val != null && val.name === item.name + "_edit") != -1) {
        //修改當前Tab的標簽，commonTag監視它並觸發changeMenu
        this.$store.commit("set_next_label", item.name);
        return false;
      }
      this.$store.commit("set_next_label", "");
      // 当页面的路由与跳转的路由不一致才允许跳转(否则会重复触发)
      if (
        this.$route.path !== item.path &&
        !(this.$route.path === "/home" && item.path === "/")
      ) {
        // 菜单路由跳转(实例)
        this.$router.push({ name: item.name, params: { type: item.type, right: (item.acode || "") } });
        //this.$router.push(item.path);
      }
      this.$store.commit("selectMenu", { item: item, type: 1 });
      this.$store.commit("get_current_label", item.label);
      if (this.IsMobile() != null) {
        this.$store.state.tab.isCollapse = true;
      }
    },
  },
  computed: {
    // 数据加载无子菜单
    noChildren() {
      //过滤无子菜单项
      return this.menuData.filter(item => !item.children && (item.meta == null || item.meta.istrun == false ));
    },
    // 数据加载有子菜单
    hasChildren() {
      return this.menuData.filter((item) => item.children);
    },
    // 获取登录后传入store的菜单数据
    menuData() {
      // 判断当前数据,如果cookie中没有从当前store中去获取
      //return JSON.parse(Cookie.get("menu")) || this.$store.state.tab.menu;
      
      localStorage.getItem("menu");
      this.$store.state.tab.menu;
      return (
        JSON.parse(localStorage.getItem("menu")) || this.$store.state.tab.menu
      );
    },
    // 切换展开与收起
    isCollapse() {
      return this.$store.state.tab.isCollapse;
    },
    cheight() {
      return parseInt(this.$store.getters.current_height) + 43 + 'px';
    },

    // 導航主題
    nav_theme() {
      return this.$store.getters.current_nav_theme.background === undefined ? { "background": "#3c8dbc", "color": "#fff" } : this.$store.getters.current_nav_theme;
    },
    //  菜單主題
    menu_theme() {
      return this.$store.getters.current_menu_theme.background === undefined ? { "background": "#304156", "color": "rgb(191, 203, 217)" } : this.$store.getters.current_menu_theme;
    },
  },
  updated() {
    this.SetFontSize(this.$store.getters.size);
  },
}
</script>
